export const Dashboard = () => {
  return (
    <>
      <h1>Dashboard</h1>
    </>
  );
};
